import React from "react";
import ThemeIconForm from "./ThemeIconForm";

/** Add Theme Icon page. */
const ThemeIconAdd = () => <ThemeIconForm mode="add" />;

export default ThemeIconAdd;
